export default __webpack_public_path__ + "static/homepageVid-429fd73ea7257e1b2225a1e6dfabd8f3.mp4";